import React, { FC } from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import Image, { ImageProps } from 'frontastic/lib/image';
import { SocialMedia } from '.';
import { StaticImageData } from 'next/image';
import { Reference } from 'types/reference';
import MarketButton from '../market-button/market-button';

interface Props {
  socialMedia?: any;
  copyright?: any;
}

const FooterBottom: FC<Props> = ({ socialMedia, copyright }) => {
  return (
    <>      
      {/* Desktop/Tablet view for screens > 1024px */}
      <div className="hidden lg:flex w-full items-center justify-between px-[20.5px] md:px-24 md:pt-0 lg:px-48 xl:px-60 2xl:px-80 py-36 xl:pb-24">
        <Typography className="pb-10 text-16 text-neutral-500 md:text-14 2xl:text-16 mt-20 text-white">
          {copyright?.children?.[0]?.children?.[0]?.text}
        </Typography>
      </div>

      {/* Mobile/Tablet view for screens <= 1024px */}
      <div className="flex flex-col items-center pt-48 lg:hidden">
        <Typography className="pb-10 text-14 text-neutral-500 mt-20 text-white">
          {copyright?.children?.[0]?.children?.[0]?.text}
        </Typography>
      </div>

    </>
  );
};

export default FooterBottom;
